import { PropsWithChildren } from "react";
import { Stack, StackProps, useBreakpointValue } from "@chakra-ui/react";

import { RequestContractFormLineItem } from "forms/RequestContractForm";
import { DesktopOnly } from "components/BreakpointVisibility";
import LineItem from "./LineItem";
import StatHeading from "./StatHeading";
import {
  MODAL_LINE_ITEM_PADDING_Y,
  MODAL_LINE_ITEM_STACK_DIRECTION,
  MODAL_PADDING_X,
} from "./modalConstants";

const LineItemRow = ({ children, ...props }: PropsWithChildren<StackProps>) => {
  const direction = useBreakpointValue(MODAL_LINE_ITEM_STACK_DIRECTION, {
    ssr: false,
  });
  return (
    <Stack
      px={MODAL_PADDING_X}
      py={MODAL_LINE_ITEM_PADDING_Y}
      direction={direction}
      {...props}
    >
      {children}
    </Stack>
  );
};

const LineItems = ({
  lineItems = [],
}: {
  lineItems: RequestContractFormLineItem[] | undefined;
}) => (
  <Stack spacing={0}>
    <DesktopOnly>
      <LineItemRow>
        <StatHeading w="25%">Ship From</StatHeading>
        <StatHeading w="25%">Ship To</StatHeading>
        <StatHeading w="25%">Mode</StatHeading>
        <StatHeading w="25%">Sales Terms</StatHeading>
      </LineItemRow>
    </DesktopOnly>
    <Stack spacing={0}>
      {lineItems?.map((lineItem, key) => (
        <LineItemRow
          key={`lineItem-${key}`}
          _odd={{ bgColor: "grey.50" }}
          _even={{ bgColor: "unset" }}
        >
          <LineItem lineItem={lineItem} />
        </LineItemRow>
      ))}
    </Stack>
  </Stack>
);

export default LineItems;
